var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-modal',{staticClass:"detail-modal desktop-modal",attrs:{"visible":_vm.showShopDetailScreen,"options":{ animation: _vm.animation }},on:{"click":_vm.detectOutsideClick}},[_c('shop-details')],1)}
var staticRenderFns = []

export { render, staticRenderFns }